import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const InBox: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('InBox');

    const items = [
        {
            title: t('item1_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753772501118/1.png',
        },
        {
            title: t('item2_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1753772501300/2.png',
        },
    ];
    return (
        <div className={`${styles.InBox} GtmModuleData-section`} data-section-id="InBox">
            <EcoSectionCommon title={t('title')} />
            <div className="trail-layout box">
                {items.map((item, index) => (
                    <div key={index} className="in-box-item">
                        <div className="in-box-item-title">{item.title}</div>
                        <div className="in-box-item-img">
                            <EcoImg className={`item-img-${index}`} pc={item.pc} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InBox;
